const styles = (theme) => ({
  paperAnchorBottom: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: 600,
      margin: '0 auto',
    },
  },
  paperAnchorTop: {
    top: 0,
  },
  container: {
    position: 'relative',
    padding: 0,
  },
  gridContainer: {
    padding: 0,
    height: '100%',

    [theme.breakpoints.up('sm')]: {
      boxShadow: `${theme.boxShadow?.container}`,
      flex: 1,
    },
  },
  header: {
    height: 84,
    padding: theme.spacing(2.5),
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',

    [theme.breakpoints.down('xs')]: {
      height: 70,
    },
  },
  reverse: {
    flexDirection: 'row-reverse',
  },
  fullContent: {
    height: '100%',
  },
  fullContentWithHeader: {
    height: 'calc(100% - 70px)',
  },
  title: {
    flexGrow: 1,
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
});

export default styles;
